let parameters = {
    chartDataSource: {
        label: 'Chart Data',
        class: 'xs12 sm12 d-flex',
        type: 'select',
        source: 'dataSources',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: true
    },
    mapTypeData: {
        label: 'Map',
        class: 'xs12 sm12',
        type: 'select',
        source: 'parameters.mapTypeData.items',
        itemText: 'text',
        itemValue: 'id', 
        items: [
          {id: 'world', text: 'World'},
          {id: 'africa', text: 'Africa'},
          {id: 'europe', text: 'Europe'},
          {id: 'usa', text: 'USA'},
          {id: 'gambia', text: 'Gambia'},
          {id: 'gambia-senegal', text: 'The Gambia and Senegal'},
          {id: 'nigeria', text: 'Nigeria'}
        ],
        value: 'world',
        item: {},
        wait: false
    },
    title: {
        label: 'Title',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: "",
        display: true,
        wait: false
    },
    subTitle: {
        label: 'Sub Title',
        source: 'parameters.never',
        items: [],
        types: [],
        class: 'xs12 sm12 d-flex',
        type: 'input',
        value: "",
        display: true,
        wait: false
    },
    tileBackgroundColor: {
        label: 'Tile Background',
        class: 'xs6 d-flex',
        groupId: 'design',
        type: 'input',
        source: 'parameters.never',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: true
    },
    tileBorderColor: {
        label: 'Tile Border',
        class: 'xs6 d-flex',
        type: 'input',
        groupId: 'design',
        source: 'parameters.never',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: true
    },
    mainBackgroundColor: {
        label: 'Color',
        class: 'xs6 d-flex',
        groupId: 'design',
        type: 'input',
        source: 'parameters.never',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: true
    },
    mainShadowColor: {
        label: 'Border',
        class: 'xs6 d-flex',
        type: 'input',
        groupId: 'design',
        source: 'parameters.never',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: true
    },
    highlightBackgroundColor: {
        label: 'Highlight Color',
        class: 'xs6 d-flex',
        groupId: 'design',
        type: 'input',
        source: 'parameters.never',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: true
    },
    highlightShadowColor: {
        label: 'Highlight Shadow',
        class: 'xs6 d-flex',
        type: 'input',
        groupId: 'design',
        source: 'parameters.never',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: true
    },
    titleColor: {
        label: 'Highlight Color',
        class: 'xs6 d-flex',
        groupId: 'design',
        type: 'input',
        source: 'parameters.never',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: true
    },
    subTitleColor: {
        label: 'Highlight Shadow',
        class: 'xs6 d-flex',
        type: 'input',
        groupId: 'design',
        source: 'parameters.never',
        itemValue: 'id',
        itemText: 'name',
        items: [],
        item: {data: [], headers: []},
        wait: true
    }
};

export default parameters;
